<template>
    <div class="login">
        <!-- Обертка для формы -->
        <div class="login-container">
            <div
                class="login-form"
            >
                <img
                    src="/images/impulse_icon.png"
                    alt="Логотип"
                >
                <span class="app-title">АРМ Врача</span>

                <div
                    v-if="timePasswordExpire"
                    class="ant-form-item info-msg"
                >
                    Внимание! Если не сменить пароль, то пользователь будет заблокирован
                    {{ $moment(timePasswordExpire).format('DD.MM.YYYY') }}
                    в
                    {{ $moment(timePasswordExpire).format('HH:mm') }}
                </div>

                <a-form
                    ref="form"
                    :model="formState"
                    :rules="formRules"
                    @submit="loginSubmit"
                >
                    <div class="input-with-lang-indicator">
                        <a-form-item
                            name="password"
                        >
                            <a-input-password
                                v-model:value="formState.password"
                                placeholder="Пароль"
                                @keyup="(e) => onPasswordChange(e, formState.password)"
                                @mousedown="onPasswordMouseDown"
                            />
                        </a-form-item>
                        <i
                            v-if="showKeyboard"
                            class="lang-indicator fa fa-keyboard-o"
                        />
                        <span
                            v-if="!showKeyboard"
                            class="lang"
                        >
                            {{ lang }}
                        </span>
                    </div>

                    <span
                        v-if="showCapsWarn"
                        class="caps-lock-warning"
                    >
                        включён Caps Lock
                    </span>

                    <a-form-item
                        name="confirm"
                        class="modifier--pd-r-25"
                    >
                        <a-input-password
                            v-model:value="formState.confirm"
                            placeholder="Подтвержение"
                            @keyup="(e) => onPasswordChange(e, formState.confirm)"
                            @mousedown="onPasswordMouseDown"
                        />
                    </a-form-item>

                    <div class="login-rules">
                        Пароль должен иметь:
                        <span
                            :class="formState.password
                                && formState.password.length >= 12 ? 'valid' : 'no-valid'"
                        >
                            <i
                                :class="formState.password && formState.password.length >= 12
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Длину не меньше 12 символов
                        </span>
                        <span
                            :class="formState.password
                                && /[A-Z]/.test(formState.password) ? 'valid' : 'no-valid'"
                        >
                            <i
                                :class="formState.password && /[A-Z]/.test(formState.password)
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Прописные буквы английского алфавита от A до Z
                        </span>
                        <span
                            :class="formState.password
                                && /[a-z]/.test(formState.password) ? 'valid' : 'no-valid'"
                        >
                            <i
                                :class="formState.password && /[a-z]/.test(formState.password)
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Строчные буквы английского алфавита от a до z
                        </span>
                        <span
                            :class="formState.password
                                && /[0-9]/.test(formState.password) ? 'valid' : 'no-valid'"
                        >
                            <i
                                :class="formState.password && /[0-9]/.test(formState.password)
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Цифры от 0 до 9
                        </span>
                        <span
                            :class="hasSpecialChars ? 'valid' : 'no-valid'"
                        >
                            <i
                                :class="hasSpecialChars
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Специальные символы ! ? @ # $ % ^ & * ( ) - _ + = ; : , . / \ |
                        </span>
                        <span
                            :class="formState.confirm
                                && formState.confirm === formState.password
                                ? 'valid'
                                : 'no-valid'"
                        >
                            <i
                                :class="formState.confirm
                                    && formState.confirm === formState.password
                                    ? 'fa fa-check-circle'
                                    : 'fa fa-times-circle'"
                            />
                            Подтверждение
                        </span>
                    </div>

                    <a-form-item>
                        <a-button
                            :disabled="!validate()"
                            type="primary"
                            html-type="submit"
                        >
                            Изменить пароль
                        </a-button>
                    </a-form-item>
                </a-form>

                <div class="forgot-pin">
                    <a @click="onRemindLater">Напомнить позже</a>
                </div>
            </div>
        </div>
        <app-version />
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { showErrorNotification } from '@/utils';
import AppVersion from '@/components/authorization/AppVersion.vue';

export default defineComponent({
    name: 'AuthorizationChangePassword',
    components: {
        AppVersion,
    },
    data() {
        return {
            formState: {
                password: null,
                confirm: null,
            },
            formRules: {
                password: [{
                    required: true,
                    message: 'Обязательное поле',
                }],
                confirm: [{
                    required: true,
                    message: 'Обязательное поле',
                }],
            },
            capsIsOn: false,
            showKeyboard: true,
            showCapsWarn: false,
            lang: null,
            timePasswordExpire: null,
        };
    },
    computed: {
        hasSpecialChars() {
            if (!this.formState.password) {
                return false;
            }
            return /[!@#$%^&*()\-_+=;:,./\\|?]/.test(this.formState.password);
        },
    },
    created() {
        if ('timePasswordExpire' in localStorage) {
            try {
                if (localStorage?.timePasswordExpire) {
                    this.timePasswordExpire = localStorage.timePasswordExpire;
                }
            } catch (error) {
                // Error handling
                console.error(error);
            }
        }
    },
    methods: {
        onPasswordMouseDown(e) {
            if (e.getModifierState('CapsLock')) {
                if (!this.showCapsWarn) {
                    this.capsIsOn = true;
                }
                if (this.capsIsOn) {
                    this.showCapsWarn = true;
                } else {
                    this.showCapsWarn = false;
                }
            } else {
                this.capsIsOn = false;
                this.showCapsWarn = false;
            }
        },
        onPasswordChange(e, value) {
            if (e.keyCode === 20) {
                this.capsIsOn = !this.capsIsOn;
                this.showCapsWarn = !this.showCapsWarn;
                return;
            }
            // {16: shift, 17: ctrl, 18: alt, 91: cmd, 32: space, 20: capsLock,
            // 8: backspace, 46: del, 38: up, 40: down, 37: left, 39: right, 13: enter}
            if (
                [16, 17, 18, 20, 32, 91, 8, 46, 38, 40, 37, 39, 13].indexOf(e.keyCode) > -1
            ) {
                return;
            }
            const testValue = value.slice(-1);
            if (/[A-Za-z]/.test(testValue)) {
                this.showKeyboard = false;
                this.lang = 'EN';
            } else if (/[ЁЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮёйцукенгшщзхъфывапролджэячсмитьбю]/.test(testValue)) {
                this.showKeyboard = false;
                this.lang = 'RU';
            }
        },
        validate() {
            if (
                this.formState.password
                && this.formState.confirm
                && this.formState.password.length >= 12
                && /[A-Z]/.test(this.formState.password)
                && /[a-z]/.test(this.formState.password)
                && /[0-9]/.test(this.formState.password)
                && /[!@#$%^&*()\-_+=;:,./\\|?]/.test(this.formState.password)
                && this.formState.confirm === this.formState.password
            ) {
                return true;
            }
            return false;
        },
        loginSubmit(e) {
            e.preventDefault();
            if (!this.validate()) {
                return;
            }

            this.$http.post('/user/pass', {
                password: this.formState.password,
            }).then((response) => {
                localStorage.username = response.data.name;
                localStorage.LoggedIn = true;
                this.$router.replace({ name: 'main' });
            }).catch((error) => {
                showErrorNotification(error.response.data.msg);
            });
        },
        async onRemindLater() {
            const hasInternet = await this.checkInternetConnection();
            if (hasInternet) {
                this.$router.push({ name: 'main' });
            } else {
                showErrorNotification(
                    'Нет соединения с интернетом. Проверьте подключение и попробуйте еще раз',
                    5000,
                );
            }
        },
        async checkInternetConnection() {
            // Проверяем базовый статус подключения
            if (!navigator.onLine) {
                return false;
            }

            // Дополнительная проверка через попытку загрузить легковесный ресурс
            try {
                const controller = new AbortController();
                const timeoutId = setTimeout(() => controller.abort(), 5000);

                await fetch('https://www.google.com/favicon.ico', {
                    method: 'HEAD',
                    mode: 'no-cors',
                    cache: 'no-cache',
                    signal: controller.signal,
                });

                clearTimeout(timeoutId);
                return true;
            } catch (error) {
                return false;
            }
        },
    },
});
</script>

<style lang="scss" scoped>
.login {
    background: url("/images/login-wall.jpg") center center / cover no-repeat rgb(255, 255, 255);
    height: 100%;
    display: flex;
}

.login-container {
    margin: auto;
    max-width: 460px;
    width: 100%;
    border-radius: 4px;
    position: relative;
}

.app-title {
    display: block;
    color: #00706c;
    font-weight: 600;
    font-size: 14px;
    font-family: Arial, sans-serif !important;
    margin-bottom: 20px;
    margin-top: 0px;
    text-align: center;
}

.login-form {
    position: relative;
    margin: auto;
    max-width: 100%;
    border-radius: 8px;
    border: 1px solid #e8e8e8;
    padding: 20px;
    background-color: transparent;
    z-index: 1;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background-color: #fff;
        opacity: 0.8;
        z-index: -1;
    }

    .ant-form-item {
        margin-block: 8px;

        &:last-child {
            margin-top: 20px;
            margin-bottom: 0;
        }
    }

    .ant-form-explain {
        margin-bottom: -17px;
        text-align: left;
        font-size: 13px;
    }

    img {
        display: block;
        margin: 0 auto 4px;
        max-width: 100px;
    }

    & .ant-btn.ant-btn-primary {
        min-width: 110px;
        height: auto;
        font-size: 14px;
        margin-bottom: 18px;

        padding: 7px 20px;
        background-color: #8dc07c;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
        box-shadow: 0px 0px 4px rgba(46, 75, 37, 0.4);
        border: none;
        color: #fff;

        &:disabled,
        &[disabled] {
            pointer-events: none;
            opacity: 0.5;
        }

        &:hover {
            background-color: #74b85d;
        }
    }

    & .ant-input,
    & .ant-input-password {
        height: 36px;
        border-radius: 4px;

        &:hover {
            border-color: #83b274;
        }

        &:focus,
        &:has(input:focus) {
            border-color: #83b274;
            box-shadow: 0 0 0 2px rgb(131, 178, 116, 0.2);
        }
    }

    & .ant-form-item-has-error .ant-input,
    & .ant-form-item-has-error .ant-input-password {
        border-color: #ff4d4f;
        box-shadow: 0 0 0 2px rgba(255, 77, 77, 0.2);
    }

    :deep(.ant-form-item-explain) {
        width: fit-content;
    }

    .error-msg,
    .no-valid,
    .caps-lock-warning {
        color: #f5222d;
    }

    .valid {
        color: #589046;
    }

    .info-msg {
        text-align: left;
        color: #ff4d4f;
        font-size: 14px;
        margin-bottom: 8px;
        max-width: 100%;
        word-break: break-word;
        white-space: pre-wrap;
        line-height: 1.4;
        padding: 8px 10px;
        background: #fff5f5;
        border: 1px solid #ffccc7;
        border-radius: 4px;
        overflow-x: hidden;
    }

    .caps-lock-warning {
        font-family: Arial;
        text-align: left;
        width: 100%;
        display: inline-block;
    }

    .input-with-lang-indicator {
        display: grid;
        grid-template-columns: auto 25px;

        .ant-form-item {
            margin: 0;
        }

        .lang-indicator {
            padding-top: 12px;
        }

        .lang {
            font-family: Arial;
            font-size: 13px;
            padding-top: 10px;
        }
    }

    .login-rules {
        text-align: left;

        span {
            display: block;

            i {
                margin-right: 5px;
            }
        }
    }

    .forgot-pin {
        text-align: center;

        a {
            text-decoration: none;
            color: #83b274;
            font-size: 14px;
            transition: color 0.3s;

            &:hover {
                color: #74b85d;
            }
        }
    }
}

.modifier {
    &--pd-r-25 {
        padding-right: 25px;
    }
}
</style>
